const PrimaryLanguages = Object.freeze({
  en: "en",
  ru: "ru",
  de: "de",
  ja: "ja",
  es: "es",
  fr: "fr",
  pt: "pt",
  it: "it",
  pl: "pl",
  hr: "hr",
  nl: "nl",
  zh: "zh",
});

export default PrimaryLanguages;
